import React from "react";
import { connect } from "react-redux";
import { Checkbox, Typography } from "antd";
import { Controller } from "react-hook-form";
import PropTypes from "prop-types";
import { ErrorLabel } from "@authzsvc/common-react-components";
import style from "./FormItemCheckbox.module.css";

const { Paragraph } = Typography;

const FormItemCheckbox = ({
  name,
  label,
  control,
  required,
  paragraph,
  error,
}) => (
  <div>
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field }) => (
        <div
          className={style["checkbox-label"]}
          style={{
            fontWeight: field.value ? "bold" : "normal",
          }}
        >
          <Checkbox {...field} checked={!!field.value}>
            {label}
          </Checkbox>
          {paragraph && <Paragraph type="secondary">{paragraph}</Paragraph>}
        </div>
      )}
    />
    {error && <ErrorLabel>Required</ErrorLabel>}
  </div>
);

FormItemCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  control: PropTypes.any.isRequired,
  required: PropTypes.bool,
  paragraph: PropTypes.string,
  error: PropTypes.any,
};

export default connect(() => ({}))(FormItemCheckbox);
